import { useAuth } from '@/hooks/useAuth';
import ClientPortalLayout from '@/components/client/ClientPortalLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { FileText, Calendar, User } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ClientDashboard() {
  const { user } = useAuth();

  return (
    <ClientPortalLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Welcome to the TinyTaxLady Client Portal</h1>
          <p className="text-muted-foreground mt-2">
            Hello, {user?.email || 'Client'}! Manage your tax documents and appointments here.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {/* Profile Card */}
          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="flex items-center justify-between">
                <User className="h-8 w-8 text-primary" />
                <Badge variant="secondary">Active</Badge>
              </div>
              <CardTitle>My Profile</CardTitle>
              <CardDescription>
                Manage your personal information
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-3">
                Update your contact details and preferences.
              </p>
              <Link 
                to="/client-portal/profile" 
                className="text-sm text-primary hover:underline font-medium"
              >
                Edit profile →
              </Link>
            </CardContent>
          </Card>

          {/* Documents Card */}
          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="flex items-center justify-between">
                <FileText className="h-8 w-8 text-primary" />
                <Badge variant="secondary">Active</Badge>
              </div>
              <CardTitle>My Documents</CardTitle>
              <CardDescription>
                Upload and manage your tax documents
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-3">
                Securely upload W-2s, 1099s, and other tax documents.
              </p>
              <Link 
                to="/client-portal/documents" 
                className="text-sm text-primary hover:underline font-medium"
              >
                Upload documents →
              </Link>
            </CardContent>
          </Card>

          {/* Appointments Card */}
          <Card className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="flex items-center justify-between">
                <Calendar className="h-8 w-8 text-primary" />
                <Badge variant="secondary">Active</Badge>
              </div>
              <CardTitle>My Appointments</CardTitle>
              <CardDescription>
                View and manage your appointments
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground mb-3">
                See upcoming appointments and schedule new ones.
              </p>
              <Link 
                to="/client-portal/appointments" 
                className="text-sm text-primary hover:underline font-medium"
              >
                View appointments →
              </Link>
            </CardContent>
          </Card>

        </div>
      </div>
    </ClientPortalLayout>
  );
}
